// eslint-disable-next-line no-shadow
export enum GeneralMutationTypes {
  SET_LAST_KNOWN_STATUS = 'SET_LAST_KNOWN_STATUS',
}
